module.exports = __webpack_public_path__ + "img/ttina.71f745c.png";